import {ARIA_LIVE_ASSERTIVE, ARIA_LIVE_POLITE} from '../constants';
import {getConfigItem, configConstants} from '@servicenow/ui-config';
import log from '../log';
import {allLogTypes as logTypes} from '@servicenow/ui-internal';

export const politeId = 'SEISMIC_ARIA_LIVE_REGION_POLITE';
export const assertiveId = 'SEISMIC_ARIA_LIVE_REGION_ASSERTIVE';

const applyAriaLiveRegionAttributes = (el, type, id) => {
	const live = type === ARIA_LIVE_ASSERTIVE || type === ARIA_LIVE_POLITE ? type : ARIA_LIVE_POLITE;
	el.setAttribute('id', id || (type === ARIA_LIVE_ASSERTIVE ? assertiveId : politeId));
	el.setAttribute('aria-live', live);
	el.setAttribute('aria-atomic', true);
	applyStyles(el);
};

const applyStyles = el => {
	el.style.position = 'absolute';
	el.style.overflow = 'hidden';
	el.style.width = '1px';
	el.style.height = '0px';
	el.style.margin = 0;
	el.style.border = 'none';
	el.style.padding = 0;
	el.style.whiteSpace = 'nowrap';
	el.style.clip = 'rect(0 0 0 0)';
	el.style.clipPath = 'inset(50%)';
};

const politeTimeout = getConfigItem(configConstants.ARIA_LIVE_POLITE_TIMEOUT);
const assertiveTimeout = getConfigItem(configConstants.ARIA_LIVE_ASSERTIVE_TIMEOUT);

const createAriaLiveRegionEl = (id, type) => {
	const el = document.createElement('SPAN');
	applyAriaLiveRegionAttributes(el, type, id);
	document.body.appendChild(el);
	return el;
};

const getAriaLiveRegionEl = type => {
	const id = type === ARIA_LIVE_ASSERTIVE ? assertiveId : politeId;
	return document.querySelector(`#${id}`) || createAriaLiveRegionEl(id, type);
};

export const actionHandler = {
	stopPropagation: true,
	effect({
		host,
		action: {
			payload: {message, type = ARIA_LIVE_POLITE}
		}
	}) {
		if (type !== ARIA_LIVE_ASSERTIVE && type !== ARIA_LIVE_POLITE) {
			process.env.NODE_ENV !== 'production' &&
				log(
					`"ARIA_LIVE_REGION_UPDATE_REQUESTED" was dispatched with action.type: ${type}. Only action.type of "assertive" or "polite" is allowed.`,
					{level: logTypes.WARN, host, origin: 'dispatch'}
				);
			return;
		}

		const ariaLiveRegionEl = getAriaLiveRegionEl(type);
		const textNode = document.createTextNode(message);
		ariaLiveRegionEl.appendChild(textNode);
		setTimeout(
			() => {
				if (textNode.parentNode === ariaLiveRegionEl) ariaLiveRegionEl.removeChild(textNode);
			},
			type === ARIA_LIVE_ASSERTIVE ? assertiveTimeout : politeTimeout
		);
	}
};
